export enum ErrorResponseMessages {
  InvalidPassword = "InvalidPassword",
  UserLimitReached = "UserLimitReached",
  WorkspaceLimitReached = "WorkspaceLimitReached",
}
